module.exports = __webpack_public_path__ + "img/coronavirus5.d9fdf83f.jpg";